module.exports = __webpack_public_path__ + "static/media/wd9.cc5e78ec.jpeg";